import { useAccountRateFieldApi } from '../api';

export const useAccountRatesTAccDgMin = () => {
  const result = useAccountRateFieldApi({
    field: 'T_ACC.DG_MIN',
  });
  return result;
};
